import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import WebsiteContainer from './components/WebsiteContainer';
import ScrollToTop from './components/ScrollToTop';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <WebsiteContainer />
    </BrowserRouter>
  );
}

export default App;